import { IApiLpAdapterSchema } from '@cbridge-packages/api-admin';

// Who opens the FIX transport (LB-5154): OUTBOUND — the gateway dials the LP,
// INBOUND — the LP connects to a cBridge FIX ingress (UNIVERSAL_FIX).
export enum LpIntegrationDirection {
  Inbound = 'INBOUND',
  Outbound = 'OUTBOUND',
}

// Normalized adapter schemas: the legacy single-schema response is expanded
// into the same schema for both connections.
export interface ILpAdapterSchemas {
  pricing: IApiLpAdapterSchema;
  // null — the adapter has no trading connection (pricing only)
  trading: IApiLpAdapterSchema | null;
  // Carried by the client by-name response only; Tenant Admin reads the direction from the adapters list.
  integrationDirection?: LpIntegrationDirection;
}

export interface ILpAdapter {
  name: string;
  integrationDirection: LpIntegrationDirection;
  // undefined — schemas were never requested; null — requested, adapter has no schema
  schemas?: ILpAdapterSchemas | null;
}

export interface ILpAdaptersStore {
  adapters: ILpAdapter[];
}

export interface ILpAdaptersStoreSegment {
  lpAdapters: ILpAdaptersStore;
}
